import React, { useState, useEffect } from "react";
import Datepicker from "../datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadFileButton,
} from "../button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddFixedAssetRegister from "../forms/AddFixedAssetsRegister/AddFixedAssetRegister";
import UploadfaFile from "../forms/UploadfaFile/UploadfaFile";
import FaUploadedFiles from "../forms/FaUploadedFiles/faUploadedFile";
import ColumnMapping from "../forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import { fixedAssetListing } from "../../../Bookclosure/Services/ApiHandler";

import styles from "./FaHeaders.module.css";

const FaHeaders = ({
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
}) => {
  const [fromDate, setFromDate] = useState("2024-01-01");
  const [toDate, setToDate] = useState("2025-01-01");

  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showFaUploadedFiles, setShowFaUploadedFiles] = useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fixedAssetID] = useState("6923ff38b2634815b2602d1d");
  const [uploadType, setUploadType] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);

  useEffect(() => {
    const fetchFilterConfig = async () => {
      try {
        const response = await fixedAssetListing(fixedAssetID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });

        if (response.data && response.data.filterAndAlignment) {
          setFilterConfig(response.data.filterAndAlignment);
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    if (fixedAssetID) {
      fetchFilterConfig();
    }
  }, [fixedAssetID]);

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setShowFilter(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
    }
  };

   const handleChangeFile = () => {
    setShowUploadExcelModal(true);
    setShowUploadFileModal(false);
  }

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleAddFiles=() => {
    setShowUploadFileModal(true);
    setShowFaUploadedFiles(false);
  }

  const handleProceedToFaUploadedFiles = (files) => {
    setUploadedFiles(files);
    setShowUploadFileModal(false);
    setShowFaUploadedFiles(true);
  };

  const handleStartMapping = () => {
    setShowFaUploadedFiles(false);
    setShowColumnMapping(true);
  };

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmitSubMapping = () => {
    setShowSubMapping(false);
    setShowFaUploadedFiles(true);
  };

  const handleFinish = () => {
    setShowFaUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");
    setShowTable(true);
  };

  const handleSuccessERPModal = () => {
    setShowERPModal(false);
    setShowERPSuccessModal(true);
  };

  const handleRemoveFile = (index) => {
   setUploadedFiles((files) => files.filter((_, i) => i !== index));
  };


  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    setShowTable(true);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          <Datepicker
            fromDate={fromDate}
            toDate={toDate}
            onFromChange={(e) => setFromDate(e.target.value)}
            onToChange={(e) => setToDate(e.target.value)}
          />

          {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )}
          {tableType === "excel" && (
            <UploadFileButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddFixedAssetRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false);
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadfaFile
          FixedAssetID={fixedAssetID}
          onClose={() => setShowUploadFileModal(false)}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onChangeFile={handleChangeFile}
          onProceedToFaUploadedFiles={handleProceedToFaUploadedFiles}
        />
      )}

      {showFaUploadedFiles && (
        <FaUploadedFiles
          uploadedFiles={uploadedFiles}
          onBack={() => {
            setShowFaUploadedFiles(false);
            setShowUploadFileModal(true);
          }}
          onAdd={handleAddFiles}
          onStartMapping={handleStartMapping}
          onFinish={handleFinish}
          onRemove={handleRemoveFile}
          onClose={() => setShowFaUploadedFiles(false)}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          FixedAssetID={fixedAssetID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowFaUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onCancel={() => {
            setShowColumnMapping(false);
          }}
          onClose={() => {
            setShowColumnMapping(false);
          }}
        />
      )}

      {showSubMapping && (
        <Submapping
          FixedAssetID={fixedAssetID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
          }}
          onSubmitMapping={handleSubmitSubMapping}
        />
      )}

      {showERPModal && (
        <ERPModal
          onClose={() => setShowERPModal(false)}
          onBack={() => {
            setShowERPModal(false);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
        />
      )}

      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}
    </>
  );
};

export default FaHeaders;
